import { GrapevineSuggestionEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineSuggestionEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineSuggestionEventsApi(configuration),
    [configuration]
  );
};
